import { render, staticRenderFns } from "./SessionContinueDialog.vue?vue&type=template&id=850ab972"
import script from "./SessionContinueDialog.vue?vue&type=script&lang=js"
export * from "./SessionContinueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports